// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.livestream-reaction-bar[data-v-bc1789e4] {
  position: absolute;
  bottom: 12px;
  left: 12px;
  z-index: 5;
}
.livestream-overlay[data-v-bc1789e4] {
  position: absolute;
  top: 12px;
  left: 12px;
  z-index: 2;
  pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./src/FanWeb/scripts/components/events/livestream/LivestreamWatchView.vue","webpack://./LivestreamWatchView.vue"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;ACDF;ADIA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EACA,oBAAA;ACDF","sourcesContent":["@import \"@/styles/breakpoint-mixin.scss\";\n\n.livestream-reaction-bar {\n  position: absolute;\n  bottom: 12px;\n  left: 12px;\n  z-index: 5;\n}\n\n.livestream-overlay {\n  position: absolute;\n  top: 12px;\n  left: 12px;\n  z-index: 2;\n  pointer-events: none;\n}\n",".livestream-reaction-bar {\n  position: absolute;\n  bottom: 12px;\n  left: 12px;\n  z-index: 5;\n}\n\n.livestream-overlay {\n  position: absolute;\n  top: 12px;\n  left: 12px;\n  z-index: 2;\n  pointer-events: none;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
